export default () => {
  const forms = document.querySelectorAll(".contact-form");

  var currentLocation = window.location.href;
  let languageVersionReqDate = "";
  let languageVersionReqDateSelect = "";

  // console.log(currentLocation);

  if (currentLocation.indexOf("es") > -1) {
    languageVersionReqDate = "Fechas solicitadas*";
    languageVersionReqDateSelect = "Fechas solicitadas seleccionadas";
  } else {
    languageVersionReqDate = "Requested Dates*";
    languageVersionReqDateSelect = "Requested Dates Selected";
  }

  if (!forms) {
    return;
  }

  forms.forEach((form) => {
    const wrappers = form.querySelectorAll(".wpcf7-form-control-wrap");

    const select = form.querySelectorAll(".wpcf7-select");

    select[0].onchange = function (e) {
      e.stopPropagation();
      e.preventDefault();
      var index = this.selectedIndex;
      var inputText = this.children[index].innerHTML.trim();
      if (inputText == "Country of Residence*") {
        select[0].classList.add("first-item");
      } else {
        select[0].classList.remove("first-item");
      }
      // console.log(inputText);
    };

    select[1].onchange = function (e) {
      e.stopPropagation();
      e.preventDefault();

      var index = this.selectedIndex;
      var inputText = this.children[index].innerHTML.trim();
      if (inputText == languageVersionReqDate) {
        select[1].classList.add("first-item");
      } else {
        select[1].classList.remove("first-item");
      }
      // console.log(inputText);
    };

    select[2].onchange = function (e) {
      e.stopPropagation();
      e.preventDefault();

      var index = this.selectedIndex;
      var inputText = this.children[index].innerHTML.trim();
      if (inputText == "How did you hear about us?*") {
        select[2].classList.add("first-item");
      } else {
        select[2].classList.remove("first-item");
      }
    };

    wrappers.forEach((wrapper) => {
      wrapper.addEventListener("mouseenter", () => {
        const message = wrapper.querySelector(".wpcf7-not-valid-tip");

        if (!message) {
          return;
        }
        message.style.display = "none";
      });
    });
  });

  $(".wpcf7-select").change(function () {
    // console.log($(this).val());

    if ($(this).val() == "0") $(this).addClass("empty");
    else $(this).removeClass("empty");
    // console.log($(this).val());
  });
  $(".wpcf7-select").change();
};

var x, i, j, l, ll, selElmnt, a, span, b, c;
/* Look for any elements with the class "custom-select": */
x = document.getElementsByClassName("custom-select");

l = x.length;
for (i = 0; i < l; i++) {
  selElmnt = x[i].getElementsByTagName("select")[0];
  ll = selElmnt.length;
  /* For each element, create a new DIV that will act as the selected item: */
  a = document.createElement("DIV");
  a.setAttribute("class", "select-selected");
  a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;

  x[i].appendChild(a);
  /* For each element, create a new DIV that will contain the option list: */
  b = document.createElement("DIV");
  b.setAttribute("class", "select-items select-hide");
  for (j = 1; j < ll; j++) {
    /* For each option in the original select element,
    create a new DIV that will act as an option item: */
    c = document.createElement("DIV");
    c.innerHTML = selElmnt.options[j].innerHTML;
    span = document.createElement("SPAN");
    span.setAttribute("class", "contact-circle");
    span.innerHTML = "";
    c.appendChild(span);
    c.addEventListener("click", function (e) {
      e.stopPropagation();
      e.preventDefault();

      /* When an item is clicked, update the original select box,
        and the selected item: */
      var y, i, k, s, h, sl, yl, span;

      const select_option = document.querySelectorAll(
        "select[name='hear'] option"
      );

      s = this.parentNode.parentNode.getElementsByTagName("select")[0];

      sl = s.length;
      h = this.parentNode.previousSibling;
      for (i = 0; i < sl; i++) {
        // if (s.options[i].innerHTML == this.innerHTML) {
        s.selectedIndex = i;
        h.innerHTML = this.innerHTML;
        y = this.parentNode.getElementsByClassName("same-as-selected");
        yl = y.length;
        for (k = 0; k < yl; k++) {
          y[k].removeAttribute("class");
        }
        this.setAttribute("class", "same-as-selected");

        select_option.forEach((el) => {
          if (el.innerText != this.firstChild.nodeValue) {
            el.removeAttribute("selected");
          } else {
            el.setAttribute("selected", true);
            el.value = this.innerText;
          }
        });

        break;
        // }
      }
      // h.click(); //this function close the select if you click on the option
    });
    b.appendChild(c);
  }
  x[i].appendChild(b);

  a.addEventListener("click", function (e) {
    /* When the select box is clicked, close any other select boxes,
    and open/close the current select box: */
    e.stopPropagation();
    e.preventDefault();
    closeAllSelect(this);
    this.nextSibling.classList.toggle("select-hide");
    this.classList.toggle("select-arrow-active");
    this.style = "color: rgb(24 52 49); font-size: 17px;";
  });
}

function closeAllSelect(elmnt) {
  /* A function that will close all select boxes in the document,
  except the current select box: */
  var x,
    y,
    i,
    xl,
    yl,
    arrNo = [];

  x = document.getElementsByClassName("select-items");
  y = document.getElementsByClassName("select-selected");

  xl = x.length;
  yl = y.length;
  for (i = 0; i < yl; i++) {
    if (elmnt == y[i]) {
      arrNo.push(i);
    } else {
      y[i].classList.remove("select-arrow-active");
    }
  }
  for (i = 0; i < xl; i++) {
    if (arrNo.indexOf(i)) {
      x[i].classList.add("select-hide");
    }
  }
}

// added arrow on the country select field

/* If the user clicks anywhere outside the select box,
then close all select boxes: */
// document.addEventListener("click", closeAllSelect);

// Requested dates
window.addEventListener("load", function () {
  // your code here

  let request_selector = document.querySelector(
    ".request-selector .select-selected"
  );
  let select_option = document.querySelectorAll(
    "select.requested-dates option"
  );

  let select_selector = document.querySelector(".select-selected");
  let requested_dates = document.querySelector(
    ".wpcf7-form-control-wrap select"
  );
  let selected_months = document.querySelector(
    ".request-selector .selected-months"
  );
  let one_2023 = document.querySelector(".request-selector .one_2023");
  let two_2024 = document.querySelector(".request-selector .two_2024");
  let checkbox_2023 = document.querySelector(
    ".request-selector p:has(.checkbox-2023)"
  );
  let checkbox_2024 = document.querySelector(
    ".request-selector p:has(.checkbox-2024)"
  );

  request_selector.addEventListener("click", function (e) {
    // console.log(select_selector.classList.contains("select-arrow-active"));
    if (select_selector.classList.contains("select-arrow-active")) {
      selected_months.style.display = "flex";
      one_2023.style.display = "flex";
      two_2024.style.display = "flex";
      checkbox_2023.style.display = "flex";
      checkbox_2024.style.display = "flex";
    } else {
      selected_months.style.display = "none";
      one_2023.style.display = "none";
      two_2024.style.display = "none";
      checkbox_2023.style.display = "none";
      checkbox_2024.style.display = "none";
    }
    e.stopPropagation();
  });

  let count = 0;
  let selectElement = document.querySelectorAll(
    ".wpcf7-list-item  label input"
  ); // Replace with the CSS selector that matches your select element
  let radioButton = document.querySelector(
    ".request-selector .select-items div"
  ); // replace "my-radio" with the ID of your radio button

  function toggleSelectAllOptions() {
    var currentLocation = window.location.href;
    let languageVersionReqDate = "";
    let languageVersionReqDateSelect = "";

    // console.log(currentLocation);

    if (currentLocation.indexOf("es") > -1) {
      languageVersionReqDate = "Fechas solicitadas*";
      languageVersionReqDateSelect = "Fechas solicitadas seleccionadas";
    } else {
      languageVersionReqDate = "Requested Dates*";
      languageVersionReqDateSelect = "Requested Dates Selected";
    }

    const selected_feild = document.querySelector(
      ".request-selector .select-selected"
    );

    if (count == 1) {
      radioButton.classList.remove("same-as-selected");
      selected_feild.innerHTML = languageVersionReqDate;
    } else if (count == 0) {
      radioButton.classList.add("same-as-selected");
      selected_feild.innerHTML = languageVersionReqDate;
    }

    if (radioButton.classList.contains("same-as-selected")) {
      for (let i = 0; i < selectElement.length; i++) {
        selectElement[i].checked = true;
        selected_feild.innerHTML = languageVersionReqDateSelect;
      }
      select_option.forEach((el) => {
        if (el.innerText == this.innerText) {
          el.setAttribute("selected", true);
        }
      });
      count = 1;
    } else {
      select_option.forEach((el) => {
        if (el.innerText == this.innerText) {
          el.setAttribute("selected", false);
        }
      });
      for (let i = 0; i < selectElement.length; i++) {
        selectElement[i].checked = false;
      }
      count = 0;
    }

    // Trigger change event on select element to notify Contact Form 7 of the change
    const event = new Event("change", { bubbles: true });
    // selectElement.dispatchEvent(event);
  }

  let unselect = document.querySelector(".unselect");
  const selected_feild = document.querySelector(
    ".request-selector .select-selected"
  );

  unselect.addEventListener("click", function () {
    var currentLocation = window.location.href;
    let languageVersionReqDate = "";
    let languageVersionReqDateSelect = "";

    // console.log(currentLocation);

    if (currentLocation.indexOf("es") > -1) {
      languageVersionReqDate = "Fechas solicitadas*";
      languageVersionReqDateSelect = "Fechas solicitadas seleccionadas";
    } else {
      languageVersionReqDate = "Requested Dates*";
      languageVersionReqDateSelect = "Requested Dates Selected";
    }

    select_option.forEach((el) => {
      el.setAttribute("selected", false);
      selected_feild.innerHTML = languageVersionReqDate;
    });
    for (let i = 0; i < selectElement.length; i++) {
      radioButton.classList.remove("same-as-selected");
      selectElement[i].checked = false;
    }
  });

  let radioButton2 = document.querySelector(
    ".request-selector .select-items div"
  ); // replace "my-radio" with the ID of your radio button
  radioButton2.addEventListener("click", toggleSelectAllOptions);

  function selectOneField() {
    var currentLocation = window.location.href;
    let languageVersionReqDate = "";
    let languageVersionReqDateSelect = "";

    // console.log(currentLocation);

    if (currentLocation.indexOf("es") > -1) {
      languageVersionReqDate = "Fechas solicitadas*";
      languageVersionReqDateSelect = "Fechas solicitadas seleccionadas";
    } else {
      languageVersionReqDate = "Requested Dates*";
      languageVersionReqDateSelect = "Requested Dates Selected";
    }

    const fields = document.querySelectorAll(
      ".year .wpcf7-list-item  label input"
    );
    const selected_feild = document.querySelector(
      ".request-selector .select-selected"
    );
    selected_feild.innerHTML = languageVersionReqDateSelect;
    fields.forEach((field) => {
      if (count == 2) {
        return;
      }
      select_option.forEach((el) => {
        // console.log(el.value)
        if (
          el.value == languageVersionReqDate ||
          el.value == languageVersionReqDateSelect
        ) {
          el.setAttribute("selected", true);
          selected_feild.innerHTML = languageVersionReqDateSelect;
        } else {
          el.setAttribute("selected", false);
        }
      });
      radioButton.classList.remove("same-as-selected");
      // console.log(this.checked + " ace " + field);

      for (let i = 0; i < selectElement.length; i++) {
        selectElement[i].checked = false;
      }
      this.checked = true;
    });
    count = 2;
  }
  const fields = document.querySelectorAll(
    ".year .wpcf7-list-item  label input"
  );
  fields.forEach((field) => {
    field.addEventListener("click", selectOneField);
  });

  // Hide the note input field when any other radio button is selected
  var radioButtons = document.querySelectorAll(".same-as-selected");
  radioButtons.forEach(function (radioButton) {
    radioButton.addEventListener("change", function () {
      noteInput.style.display = "none";
    });
  });

  let country_field = document.querySelector("#country-selector");
  let country = document.querySelector(".country");

  country_field.addEventListener("click", function (el) {
    country.classList.toggle("select-arrow-active");
  });
});

$(function () {
  var otherDiv = $(".select-items div").last();
  let alldiv = $(".select-items div");
  let $input = $(".other-input-field");

  $input.detach().insertAfter(otherDiv);

  alldiv.click(function (el) {
    var $this = $(this);
    //  console.log("ace Others" + $this.text());

    if ($this.text() == "Other" || $this.text() == "Otro") {
      $this.css("border", "none");
      $input.css("display", "block");
    } else {
      otherDiv.removeAttr("style");
      $input.css("display", "none");
    }
  });
});

//  the code removes the file input if it is empty. This allows Safari IOS to submit the form.

// $("body").on("click", ".wpcf7-submit", function (e) {
//   $("select[name='hear'] option").each(function () {
//     if ($(this).val() === "") {
//       $(this).remove();
//     }
//   });
//   $("#hear_select").val();
// });


